export const styles = {
    panel: "rounded bg-gray-100 border-gray-300 border",
    panelCard: "rounded border-4 border-white bg-gray-100 shadow-md hover:border-blue-400 hover:bg-blue-100 transition-all duration-200 ease-out",
    panelCardHighlighted: "rounded border-4 border-blue-400 bg-blue-100 transition-all duration-200 ease-out shadow-md"
}